import {Component, Input, OnInit} from '@angular/core';
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";


@Component({
    selector: 'im-import-data',
    templateUrl: './im-import-data.component.html',
    standalone: false
})
export class ImImportDataComponent implements OnInit {
    @Input() objectId: number;

    initialized: boolean = false;
    importData: WidgetData;

    ngOnInit() {
        this.refresh();
    }

    constructor() {
    }

    refresh() {
        this.initialized = true;
        this.refreshImportData();
    }

    refreshImportData() {
        this.importData = WidgetFactory.createWidgetEntityData(
            'im.object.component.import-data.component',
            'Import Data',
            'im.ImImport',
            this.objectId
        );
    }
}
